module.exports = __webpack_public_path__ + "static/circle-black-21f8e0ee8f94f1f78eb9cb5ed289e0c7.png";